<template>
  <div id="iosInstall" v-if="showThis">
      <div class="closeThis" v-on:click="closeThis">
        <svg id="modal-close" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M 0,0 L 20,20 M 0,20 L 20,0" stroke-width=4/></path></svg>
      </div>
    <ul>
      <li>Что бы добавить приложение "оплата микрозаймов ООО МКК ФИНМОЛ", на главный экран.</li>
      <li>
        <span>1. Нажмите </span>
        <svg  x="0px" y="0px" viewBox="0 0 293.399 293.399"><path d="M185.711,39.694L156.052,4.357c-0.092-0.103-0.207-0.174-0.299-0.277c-0.457-0.517-0.968-0.979-1.507-1.403c-0.071-0.054-0.125-0.114-0.196-0.158C152,0.957,149.476,0,146.702,0c-2.774,0-5.298,0.963-7.348,2.518c-0.071,0.049-0.125,0.103-0.196,0.158c-0.538,0.43-1.05,0.892-1.507,1.403c-0.092,0.103-0.212,0.174-0.299,0.277l-29.659,35.338c-4.335,5.156-3.66,12.858,1.501,17.198c5.167,4.324,12.869,3.655,17.198-1.512l8.104-9.654v151.016c0,6.739,5.461,12.205,12.205,12.205c6.744,0,12.205-5.466,12.205-12.205V45.732l8.104,9.654c2.41,2.877,5.874,4.362,9.355,4.362c2.763,0,5.553-0.936,7.838-2.85C189.372,52.558,190.046,44.856,185.711,39.694z"/><path d="M232.819,293.399H60.586c-13.092,0-23.742-10.65-23.742-23.736V97.425c0-13.086,10.65-23.736,23.742-23.736h44.247c6.744,0,12.205,5.466,12.205,12.205s-5.461,12.211-12.205,12.211H61.255v170.884h170.89V98.099h-42.593c-6.744,0-12.205-5.466-12.205-12.211c0-6.739,5.461-12.205,12.205-12.205h43.262c13.092,0,23.742,10.65,23.742,23.736v172.239C256.561,282.75,245.911,293.399,232.819,293.399z"/></svg>
      </li>
      <li>
        <span>2. Выберите На экран Домой</span>
        <img src="/img/iosExample.PNG" alt="">
      </li>
    </ul>
      <p>
        <span></span>


      </p>
  </div>
</template>

<script>
  export default {
    name: "ios",
    data:function(){
      return {
        showThis:false
      }
    },
    methods:{
      closeThis:function () {
        this.showThis = false
      }
    },
    created() {
      try {
        //костыль для iphone
        const isIos = () => {
          const userAgent = window.navigator.userAgent.toLowerCase();
          return /iphone|ipad|ipod/.test( userAgent );
        };
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        if (isIos() && !isInStandaloneMode()) {
          this.showThis = true;
        }
      } catch (e) {
        alert(e);
      }
    }
  }
</script>

<style scoped>
  #iosInstall{position: fixed;bottom: 2vw;width: 90vw;left:calc(2vw - 3px);background: white;border: 3px solid green;padding: 10vw 3vw 3vw;font-size: 4.5vw}
  .closeThis{width: 5vw;height: 5vw;position: absolute;top:3vw;right: 3vw;cursor: pointer;}
  .closeThis svg{stroke: red;pointer-events: none}
  #iosInstall p{padding: 2vw 0;}
  #iosInstall p span{vertical-align: middle;}
  #iosInstall p svg{vertical-align: middle;margin: 0 0.5vw}
  ul{}
  li{display: flex;align-items: center;justify-content: space-between;text-align: center;padding-bottom: 2vw;}
  li span{width: 63vw;text-align: left}
  li svg{width: 8vw;height: 8vw;fill:#2f8df5;margin-right: 6.5vw}
  li img{width: 20vw;}
</style>